<template lang="pug">
include ../pug/svg
div.block(:class="blockClasses" @mouseleave="focus=null" :style="blockStyles")
	figure
		picture(:class="pictureClasses")
			img(v-if="imageSrc" :src="imageSrc" :alt="imageAlt" @load="imageChanged")
		contenteditable(v-if="block.settings.figcaption&&imageSrc" tag="figcaption" :spellcheck="(focus===1)" :class="{fade:focus&&focus!==1}" v-model="image.figcaption" :noNL="true" @focus="focus=1" @blur="focus=null" @keyup="blockUpdated" :data-placeholder="placeholder")
		div.butdbl.text(:class="{unselected : !imageSrc}")
			button.but(type="button" @click="selectMedia()") Media
			button.but(type="button" @click="removeMedia()")
				span Remove Media
				+svg(svg-filename="iconBin")
			button.but(type="button" @click="embedMedia()") Embed
	div.modal.settings(v-if="block.settings.active")
		ModalBar(label="Block Settings" :useDrag="true" @close="toggleSettings()")
		form.body
			fieldset.fgroup
				FieldBoolean.c2(
					v-model="block.settings.fullwidth"
					label="Fullwidth"
					@fieldUpdated="blockUpdated")
				FieldBoolean.c2(
					v-model="block.settings.figcaption"
					label="Use Caption"
					@fieldUpdated="figcaptionUpdated")
				FieldRatio.c2(
					v-model:ratio="block.settings.ratio"
					label="Image Ratio"
					@fieldUpdated="blockUpdated")
				FieldBoolean.c2(
					v-model="block.settings.contain"
					label="Contain Media"
					@fieldUpdated="blockUpdated")
				FieldColour.c2(
					label="Background Colour"
					v-model:colour="block.settings.bgColor",
					@fieldUpdated="blockUpdated")
				FieldPadding(
					class="c2"
					v-model:padTop="block.settings.padTop"
					v-model:padBottom="block.settings.padBottom" 
					@fieldUpdated="blockUpdated")
			div.foot
				span.req Required
				button.but.pri(type="button" @click="toggleSettings()") Apply
				button.but.sec(type="button" @click="resetSettings()") Reset
</template>

<script>
import contenteditable from 'vue-contenteditable';
import FieldBoolean from '../components/FieldBoolean';
import FieldPadding from '../components/FieldPadding';
import FieldColour from '../components/FieldColour';
import FieldRatio from '../components/FieldRatio';
import ModalBar from '../components/ModalBar';

export default {
	name: 'BlockImageSingle',
	props:['block'],
	emits: ['blockUpdated', 'toggleSettings', 'resetSettings', 'showMediaModal', 'showEmbedModal', 'removeMedia'],
	components: {
		contenteditable,
		ModalBar,
		FieldBoolean,
		FieldPadding,
		FieldColour,
		FieldRatio,
	},
	data() {
		return {
			focus: null,
			mediaType: 'image',
			placeholder: 'Caption placeholder',
		}
	},
	computed: {
		settings() {
			return this.block.settings;
		},
		blockClasses() {
			let classes = [
				this.block.type,
				this.block.subtype,
			];
			
			if (this.settings.fullwidth) {
				classes.push('fullwidth');
			}
			
			if (this.settings.padTop) {
				classes.push(this.settings.padTop);
			}
			
			if (this.settings.padBottom) {
				classes.push(this.settings.padBottom);
			}
			
			return classes.join(' ');
		},
		blockStyles() {
			let styles = [];

			if (this.settings.bgColor) {
				styles.push('background-color:#'+this.settings.bgColor);
			}

			return styles.join(';');
		},
		pictureClasses() {
			let classes = [
				'ratio',
				this.settings.ratio,
				'posx' + this.image.positionX,
				'posy' + this.image.positionY,
			]
			
			if (this.settings.contain) {
				classes.push('contain');
			}
				
			return classes.join(' ');
		},
		image() {
			return this.block.content.images[0];
		},
		imageSrc() {
			if (this.image.media) {
				return this.image.media.mediaUrl;
			} else if (this.image.embed) {
				return this.image.embed.mediaUrl;
			}
			
			return null;
		},
		imageAlt() {
			if (this.image.media) {
				return this.image.media.seoAlt;
			} else if (this.image.embed) {
				return this.image.embed.seoAlt;
			}
			
			return null;
		},
	},
	methods: {
		blockUpdated() {
			this.$emit('blockUpdated');
		},
		figcaptionUpdated() {
			if (!this.block.settings.figcaption) {
				// reset figcaption
				this.image.figcaption = null;
			} else {
				this.imageChanged();
			}
			
			this.blockUpdated();	
		},
		toggleSettings() {
			this.$emit('toggleSettings', this.block);
		},
		resetSettings() {
			this.$emit('resetSettings', this.block);
		},
		selectMedia() {
			// pass media type and block for insertion
			this.$emit('showMediaModal', {
				mediaType: this.mediaType,
				block: this.block,
				insertIndex: 0,
			});
		},
		embedMedia() {
			// pass media type and block for insertion
			this.$emit('showEmbedModal', {
				mediaType: this.mediaType,
				block: this.block,
				insertIndex: 0,
			});
		},
		removeMedia() {
			this.$emit('removeMedia', {
				block: this.block,
				index: 0,
			});
		},
		imageChanged() {
			if (!this.image.figcaption && this.image.media) {
				// update caption
				this.image.figcaption = this.image.media.seoDescription;
			}
		},
	},
}
</script>

<style lang="scss">
</style>
